var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 218,
    viewBox: "0 0 237 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.715 193.629C119.602 195.255 117.131 196.1 114.66 196.1C112.189 196.1 109.718 195.287 107.605 193.629C88.1624 178.446 34.3225 135.075 21.5777 110.073C5.97195 79.4468 15.2379 40.2697 42.3204 22.5832C51.2287 16.7635 60.9173 14 70.5084 14C87.0895 14 103.248 22.2581 114.205 37.2786C114.432 37.6037 114.887 37.6037 115.115 37.2786C126.071 22.2581 142.23 14 158.811 14C168.402 14 178.091 16.7635 186.999 22.5832C214.082 40.2697 223.347 79.4468 207.709 110.073C194.997 135.075 141.157 178.446 121.715 193.629ZM182.577 30.0284C175.327 25.2817 167.102 22.7783 158.811 22.7783C144.213 22.7783 130.591 30.191 121.39 43.1308L115.115 51.9416C114.887 52.2667 114.432 52.2667 114.205 51.9416L107.93 43.1308C98.7288 30.191 85.1063 22.7783 70.5084 22.7783C62.2178 22.7783 54.0248 25.2817 46.7421 30.0284C23.3659 45.2766 15.4004 79.3492 28.9905 105.944C41.085 129.645 96.0628 173.667 112.644 186.574C113.392 187.159 114.172 187.289 114.66 187.289C115.18 187.289 115.928 187.159 116.708 186.574C133.257 173.667 188.234 129.645 200.361 105.944C213.919 79.3492 205.954 45.3091 182.577 30.0284Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 15,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.5f37dd4954f3f6bbcddafeb7203a9828.svg";
export { ForwardRef as ReactComponent };